import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { DraftAccountPage } from '@bingads-webui-campaign-react/draft-error-page';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';

const DraftAccountPageWraperInternal = React.memo((props) => {
  const appActivity = useMemo(() => {
    const appScenario = props.instrumentation.appScenario.create();
    return appScenario.appActivity.create();
  }, [props.instrumentation]);

  return (
    <DraftAccountPage
      logTrace={appActivity.trace}
      logError={appActivity.error}
      serverContext={props.serverContext}
    >
      {props.children}
    </DraftAccountPage>
  );
});

DraftAccountPageWraperInternal.propTypes = {
  serverContext: PropTypes.shape({
    CurrentCustomer: PropTypes.shape({
      Id: PropTypes.number,
    }),
    CurrentUser: PropTypes.shape({
      Id: PropTypes.number,
    }),
    Permissions: PropTypes.shape({}),
    DynamicPermissions: PropTypes.shape({}),
  }).isRequired,
  instrumentation: PropTypes.shape({
    appScenario: PropTypes.any,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export const DraftAccountPageWraper = withServerContext(withInstrumentation(DraftAccountPageWraperInternal));
